import { supabase } from "@/integrations/supabase/client";

export type ReactivateAgentResult =
  | { ok: true }
  | { ok: false; error: string; blocked?: boolean };

/**
 * Reativa o agente de IA numa conversa (mesma lógica do toggle manual no inbox).
 */
export async function reactivateConversationAgent({
  conversationId,
  leadId,
  memberId,
  workspaceId,
}: {
  conversationId: string;
  leadId: string;
  memberId: string | null;
  workspaceId: string | null;
}): Promise<ReactivateAgentResult> {
  const { data: blocked, error: blockError } = await supabase.rpc(
    "lead_has_agent_disabled_stage",
    { p_lead_id: leadId },
  );
  if (blockError) {
    console.error("lead_has_agent_disabled_stage:", blockError);
  } else if (blocked === true) {
    return {
      ok: false,
      blocked: true,
      error: "O lead está em um estágio configurado para desligar a IA.",
    };
  }

  const { error } = await supabase.rpc("change_conversation_state" as never, {
    _conversation_id: conversationId,
    _new_state: "active",
    _reason: "agent_reactivated",
    _actor_member_id: memberId ?? null,
    _enable_followup: true,
    _clear_escalated: true,
    _clear_pending_handoff: true,
  } as never);
  if (error) {
    const message = String(error.message ?? "");
    if (message.includes("lead_stage_blocks_agent_resume")) {
      return {
        ok: false,
        blocked: true,
        error: "O lead está em um estágio configurado para desligar a IA.",
      };
    }
    return { ok: false, error: message || "Não foi possível reativar o agente." };
  }

  try {
    await supabase.rpc("clear_conversation_inbound_guard" as never, {
      p_conversation_id: conversationId,
      p_human_bypass_hours: 0,
    } as never);
  } catch (e) {
    console.warn("clear_conversation_inbound_guard failed", e);
  }

  if (memberId && workspaceId) {
    const { error: insertErr } = await supabase.from("member_activity_log").insert({
      workspace_id: workspaceId,
      member_id: memberId,
      conversation_id: conversationId,
      action_type: "ai_enabled",
      metadata: { member_name: "Membro", source: "escalation_resolve" },
    });
    if (insertErr) console.error("Erro ao inserir log ai_enabled:", insertErr);
  }

  return { ok: true };
}
